// src/jira/version/types.ts
var JiraVersionAriResourceOwner = "jira", JiraVersionAriResourceType = "version";

export {
  JiraVersionAriResourceOwner,
  JiraVersionAriResourceType
};
